import React, { useState } from "react";
import NextPrev from "../../../Helpers/Components/NextPrev";
import { setBooking, setExcess, setStep } from "../../../Reducer/bookingSlice";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Handler from "../../../Helpers/Components/Handler";
import White from "../../../Assets/images/white-bg.avif"
import Compressor from 'compressorjs';

const Other = (props) => {
    const dispatch = useDispatch()
    const booking = useSelector(state => state?.booking?.booking)
    const [loading, setLoading] = useState(false)
    const [pendingPhoto, setPendingPhoto] = useState([]) 
    const setSteps = () => {
        dispatch(setStep(2))
    }
    const handleNext = async () => {
        if ((((Number(booking?.package || 0) * Number(booking?.totalDays || 0)) + (Number(booking?.point) === 0.5 ? 150 : 0)) - (Number(booking?.km?.end || 0) - Number(booking?.km?.start || 0)) < 0) > 0 && !(Number(booking?.excess?.kmCharges || 0))) {
            toast.error("Excess KM Charges is required")
        } else if ((Number(booking?.fuel?.end || 0) - Number(booking?.fuel?.start || 0)) < 0 && !(Number(booking?.excess?.fuelCharges))) {
            toast.error("Excess Fuel Charges is required")
        } else if (Number(booking?.excess?.timeUsed || 0) > 0 && !Number(booking?.excess?.timeCharges || 0)) {
            toast.error("Excess Hour Charges is required")
        } else {
            let dataToBeSent = {
                excess: { amount: booking?.excess?.amount || 0, fuelCharges: booking?.excess?.fuelCharges || 0, fuelConsumed: booking?.excess?.fuelConsumed || 0, kmCharges: booking?.excess?.kmCharges || 0, kmDriven: booking?.excess?.kmDriven || 0, timeCharges: booking?.excess?.timeCharges || 0, timeUsed: booking?.excess?.timeUsed || 0 },
                excessCharges: booking?.excessCharges?.length ? booking?.excessCharges?.filter(element => element?.amount) : []
            }
            setLoading(true)
            const response = await Handler({ method: 'patch', data: dataToBeSent, url: `/booking/close/fourth/update/${props?.bookingId}` })
            if (response?.success) {
                if (pendingPhoto?.length) {
                    const formData = new FormData()
                    pendingPhoto?.map(element => formData?.append('pending', element?.file))
                    const response = await Handler({ method: 'patch', url: `/booking/pending/third/update/${props?.bookingId}`, data: formData, headers: { 'Content-Type': 'multipart/form-data' } })
                    if (response?.success) {
                        dispatch(setStep(4))
                        dispatch(setBooking({ pendingPhoto: response?.data?.length ? response?.data?.map(element => { return { url: element, file: element } }) : [] }))
                    } else {
                        setLoading(false)
                        toast.error(response?.message)
                    }
                } else {
                    dispatch(setStep(4))
                }
            } else {
                toast.error(response?.message);
            }
            setLoading(false)
        }
    }
    const handleExcessCharges = (e, type, name) => {
        const value = Array.isArray(booking?.excessCharges) ? booking.excessCharges.filter((element) => element?.name !== type) : [];
        const already = Array.isArray(booking?.excessCharges) ? booking.excessCharges.find((element) => element?.name === type) : null;
        const updatedEntry = { ...(already || {}), name: type, [name]: e.target.value, };
        const updatedValue = [...value, updatedEntry];
        dispatch(setBooking({ excessCharges: updatedValue }));
    };
    const handleExcess = (e) => {
        dispatch(setExcess({ [e.target.name]: e.target.value }))
    }
    const checkFileSize = async (file) => {
        if (file.size > 4.5 * 1024 * 1024) {
            toast.error('Compressed image size exceeds 4.5 MB.');
        } else {
            const value = Array.isArray(booking?.pendingPhoto) ? booking.pendingPhoto : [];
            const updatedValue = [...value, { url: URL.createObjectURL(file), file: file }];
            setPendingPhoto((prev) => ([...prev, { url: URL.createObjectURL(file), file: file }]))
            dispatch(setBooking({ pendingPhoto: updatedValue }))
        }
    };
    const compressImage = (file) => {
        new Compressor(file, {
            quality: 0.9,
            convertSize: 1 * 1024 * 1024,
            success(result) {
                checkFileSize(result);
            },
            error(err) {
                toast.error(err.message);
            },
        });
    };
    const handleImage = (event) => {
        if (event.target.files[0]) {
            compressImage(event.target.files[0]);
        }
    };
    return (
        <React.Fragment>
            <div className="row">
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="kmDriven" className="form-label"> Excess KM Driven </label>
                        <input name="kmDriven" id="kmDriven" autoComplete="off" disabled className="form-control input-theme text-uppercase" value={booking?.excess?.kmDriven || ""} />
                    </div>
                </div>
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="kmCharges" className="form-label"> Excess KM Charges </label>
                        <input readOnly name="kmCharges" id="kmCharges" autoComplete="off" disabled className="form-control input-theme text-uppercase" value={booking?.excess?.kmCharges || ""} />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="fuelConsumed" className="form-label"> Excess Fuel Consumed </label>
                        <input name="fuelConsumed" id="fuelConsumed" autoComplete="off" disabled className="form-control input-theme text-uppercase" value={booking?.excess?.fuelConsumed || ""} />
                    </div>
                </div>
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="fuelCharges" className="form-label"> Excess Fuel Charges </label>
                        <input name="fuelCharges" id="fuelCharges" onChange={(e) => { if (/^\d{0,}$/.test(e.target.value)) { handleExcess(e) } }} autoComplete="off" disabled={loading || ((Number(booking?.fuel?.end) - Number(booking?.fuel?.start)) < 0 ? false : true)} className="form-control input-theme text-uppercase" value={booking?.excess?.fuelCharges || ""} />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="timeUsed" className="form-label"> Excess Hour Used </label>
                        <input name="timeUsed" id="timeUsed" autoComplete="off" disabled={loading} className="form-control input-theme text-uppercase" onChange={(e) => { if (/^\d{0,}$/.test(e.target.value)) { handleExcess(e) } }} value={booking?.excess?.timeUsed || ""} />
                    </div>
                </div>
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="timeCharges" className="form-label"> Excess Hour Charges </label>
                        <input name="timeCharges" id="timeCharges" autoComplete="off" disabled={loading} className="form-control input-theme text-uppercase" onChange={(e) => { if (/^\d{0,}$/.test(e.target.value)) { handleExcess(e) } }} value={booking?.excess?.timeCharges || ""} />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="fineCharges" className="form-label"> Fine Charges </label>
                        <input name="fineCharges" id="fineCharges" autoComplete="off" disabled={loading} className="form-control input-theme text-uppercase" onChange={(e) => { if (e.target.value == Number(e.target.value)) { handleExcessCharges(e, "fine", "amount") } }} value={booking?.excessCharges?.length ? (booking?.excessCharges?.filter(element => element?.name === "fine")?.length ? booking?.excessCharges?.filter(element => element?.name === "fine")[0]?.amount : "") : ""} />
                    </div>
                </div>
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="fineRemarks" className="form-label"> Fine Remarks </label>
                        <input name="fineRemarks" id="fineRemarks" autoComplete="off" disabled={loading} className="form-control input-theme text-uppercase" onChange={(e) => handleExcessCharges(e, "fine", "remarks")} value={booking?.excessCharges?.length ? (booking?.excessCharges?.filter(element => element?.name === "fine")?.length ? booking?.excessCharges?.filter(element => element?.name === "fine")[0]?.remarks : "") : ""} />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="damageCharges" className="form-label"> Damage Charges </label>
                        <input name="damageCharges" id="damageCharges" autoComplete="off" disabled={loading} className="form-control input-theme text-uppercase" onChange={(e) => { if (e.target.value == Number(e.target.value)) { if (!Number(booking?.excessCharges?.length ? (booking?.excessCharges?.filter(element => element?.name === "damage")?.length ? booking?.excessCharges?.filter(element => element?.name === "damage")[0]?.amount : 0) : 0)) { setPendingPhoto([]) } handleExcessCharges(e, "damage", "amount") } }} value={booking?.excessCharges?.length ? (booking?.excessCharges?.filter(element => element?.name === "damage")?.length ? booking?.excessCharges?.filter(element => element?.name === "damage")[0]?.amount : "") : ""} />
                    </div>
                </div>
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="damageRemarks" className="form-label"> Damage Remarks </label>
                        <input name="damageRemarks" id="damageRemarks" autoComplete="off" disabled={loading} className="form-control input-theme text-uppercase" onChange={(e) => handleExcessCharges(e, "damage", "remarks")} value={booking?.excessCharges?.length ? (booking?.excessCharges?.filter(element => element?.name === "damage")?.length ? booking?.excessCharges?.filter(element => element?.name === "damage")[0]?.remarks : "") : ""} />
                    </div>
                </div>
            </div>
            {
                Number(booking?.excessCharges?.length ? (booking?.excessCharges?.filter(element => element?.name === "damage")?.length ? booking?.excessCharges?.filter(element => element?.name === "damage")[0]?.amount : 0) : 0) > 0
                    ?
                    <>
                        {booking?.pendingPhoto?.length ?
                            booking?.pendingPhoto?.map((element, i) => {
                                return (
                                    <div className="row" key={i}>
                                        <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                                            <div className="mb-3">
                                                <div className="main-div">
                                                    <img src={element?.url || White} alt="Pending" className="kycPhotoImg" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                            : ""}

                        <div className="mb-3">
                            <label htmlFor="pending"><i className="fa-solid fa-plus cursor-pointer fs-5"></i></label>
                            <input type="file" accept="image/*" className="d-none" name="pending" id="pending" onChange={(e) => { handleImage(e) }} />
                        </div>
                    </>
                    : ""
            }
            <div className="row">
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="otherCharges" className="form-label"> Other Charges </label>
                        <input name="otherCharges" id="otherCharges" autoComplete="off" disabled={loading} className="form-control input-theme text-uppercase" onChange={(e) => { if (e.target.value == Number(e.target.value)) { handleExcessCharges(e, "other", "amount") } }} value={booking?.excessCharges?.length ? (booking?.excessCharges?.filter(element => element?.name === "other")?.length ? booking?.excessCharges?.filter(element => element?.name === "other")[0]?.amount : "") : ""} />
                    </div>
                </div>
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="otherRemarks" className="form-label"> Other Remarks </label>
                        <input name="otherRemarks" id="otherRemarks" autoComplete="off" disabled={loading} className="form-control input-theme text-uppercase" onChange={(e) => handleExcessCharges(e, "other", "remarks")} value={booking?.excessCharges?.length ? (booking?.excessCharges?.filter(element => element?.name === "other")?.length ? booking?.excessCharges?.filter(element => element?.name === "other")[0]?.remarks : "") : ""} />
                    </div>
                </div>
            </div>
            <NextPrev step={3} setStep={setSteps} last={4} onClick={handleNext} loading={false} />
        </React.Fragment>
    )
}

export default Other;